import type { CompetitorsDto } from '@app/api/routes/locationCompetitors/dtos'
import type { SelectFc } from '@app/types/QueryOptions'
import type { FilterOption } from '@app/types/filter'

export const getFilterCompetitorsFormEntities: SelectFc<FilterOption, CompetitorsDto> = entityResponse =>
  entityResponse?.map(({ id, text }) => ({
    value: id,
    label: text
  })) ?? []
